// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","wrapper":"_2ITUSB","icon":"Nw50ze","tit_area":"kYAjmH","AniFadeIn":"IOY2lU","AniFadeOut":"mO23R9","AniRotate":"A684Uu","AniPlaceholderFadeOut":"A3hPn9"};